import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styling/Navbar.css';
import logo from '../assets/images/logo.svg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner container">
        <div className="navbar-brand">
          <Link to="/" style={{marginBottom: '15px'}}>
          <svg width="120px" height="35px" viewBox="0 0 370 109.9750389862925" className="looka-1j8o68f">
            <defs id="SvgjsDefs1665"></defs>
            <g id="SvgjsG1666" featurekey="hmhgWD-0" transform="matrix(1.7815780813918796,0,0,1.7815780813918796,-7.019707429843363,10.74114019257387)" fill="#fffefe">
              <title xmlns="http://www.w3.org/2000/svg">Podcast</title>
              <path xmlns="http://www.w3.org/2000/svg" d="M34.34,10.81H29.66a7,7,0,0,0-7,7V40.15a7,7,0,0,0,4.59,6.55v9H30V47.13h4v8.55h2.71v-9a7,7,0,0,0,4.59-6.55V17.79A7,7,0,0,0,34.34,10.81Zm0,33.61H29.66a4.28,4.28,0,0,1-4.27-4.27v-.43h4.49V37H25.39V34.37h4.49V31.66H25.39V29.54h4.49V26.83H25.39V24.37h4.49V21.65H25.39V17.79a4.28,4.28,0,0,1,4.27-4.27h4.69a4.28,4.28,0,0,1,4.27,4.27v3.86H34.12v2.71h4.49v2.46H34.12v2.71h4.49v2.12H34.12v2.71h4.49V37H34.12v2.71h4.49v.43A4.28,4.28,0,0,1,34.34,44.42ZM6.65,29A25.11,25.11,0,0,0,11.9,44.43L9.75,46.09a28.07,28.07,0,0,1,0-34.2l2.15,1.65A25.11,25.11,0,0,0,6.65,29Zm53.42,0a27.8,27.8,0,0,1-5.82,17.12L52.1,44.43a25.36,25.36,0,0,0,0-30.89l2.15-1.65A27.8,27.8,0,0,1,60.07,29Zm-6.47,0a21.64,21.64,0,0,1-2.68,10.42l-2.38-1.31A18.91,18.91,0,0,0,48.6,20L51,18.67A21.63,21.63,0,0,1,53.59,29ZM15.46,19.85A18.91,18.91,0,0,0,15.4,38L13,39.26a21.62,21.62,0,0,1,.08-20.73Zm31.66,4.44a15.9,15.9,0,0,1-.17,9.9l-2.56-.89a13.19,13.19,0,0,0,.15-8.2ZM18.88,29a13.09,13.09,0,0,0,.73,4.32l-2.56.89a15.9,15.9,0,0,1-.17-9.9l2.59.8A13.11,13.11,0,0,0,18.88,29Z"/>
            </g>
            <g id="SvgjsG1667" featurekey="1RRcwp-0" transform="matrix(5.236698600971414,0,0,5.236698600971414,117.48638582017786,2.1407650409456664)" fill="#ffffff">
              <path d="M6.4 20 l-2.2 0 l-3.72 -9.16 l2.58 0 l2.24 5.48 l2.22 -5.48 l2.6 0 z M14.56 20 l-2.6 0 l0 -9.16 l2.6 0 l0 9.16 z M13.26 9.74 c-0.86 0 -1.56 -0.7 -1.56 -1.54 c0 -0.42 0.16 -0.8 0.46 -1.08 c0.3 -0.3 0.68 -0.46 1.1 -0.46 c0.84 0 1.54 0.7 1.54 1.54 s-0.7 1.54 -1.54 1.54 z M22.28 20.18 c-0.72 0 -1.54 -0.1 -2.26 -0.8 l-0.1 -0.1 l0 0.72 l-2.42 0 l0 -14.68 l2.42 0 l0 6.32 l0.1 -0.08 c0.66 -0.6 1.42 -0.9 2.26 -0.9 c1.28 0 2.48 0.48 3.38 1.38 c0.9 0.92 1.4 2.12 1.4 3.38 s-0.5 2.46 -1.4 3.38 c-0.92 0.9 -2.12 1.38 -3.38 1.38 z M19.92 15.42 c0 1.32 1.08 2.42 2.36 2.42 s2.36 -1.1 2.36 -2.42 c0 -1.3 -1.08 -2.42 -2.36 -2.42 s-2.36 1.12 -2.36 2.42 z M32.86 20.22 l-0.02 0 c-0.58 0 -1.18 -0.14 -1.74 -0.4 c-0.52 -0.22 -1 -0.58 -1.44 -1.04 c-0.7 -0.76 -1.12 -1.76 -1.22 -2.8 c-0.02 -0.18 -0.04 -0.36 -0.04 -0.56 c0 -0.4 0.06 -0.82 0.16 -1.24 c0.18 -0.8 0.56 -1.54 1.1 -2.1 c0.4 -0.44 0.86 -0.78 1.44 -1.06 c0.54 -0.26 1.14 -0.38 1.76 -0.38 c0.64 0 1.22 0.12 1.76 0.38 c0.6 0.28 1.08 0.64 1.44 1.06 c0.52 0.56 0.92 1.28 1.12 2.1 c0.1 0.38 0.14 0.78 0.14 1.24 l0 0.46 l-6.72 0 l0.02 0.14 c0.26 1.24 1.2 2.14 2.24 2.14 l0.02 0 c0.58 -0.04 1.22 -0.4 1.6 -0.72 l0.22 -0.18 l1.66 1.44 l-0.3 0.26 c-0.22 0.2 -0.5 0.44 -0.8 0.6 l-0.02 0 c-0.72 0.42 -1.5 0.64 -2.38 0.66 z M32.86 12.719999999999999 c-0.78 0 -1.56 0.54 -1.98 1.38 l-0.08 0.16 l4.14 0 l-0.08 -0.16 c-0.46 -0.86 -1.22 -1.38 -2 -1.38 z M43.1 20 l-3.16 0 l3.06 -5.04 c-2.48 -0.2 -4.46 -2.26 -4.46 -4.78 c0 -2.66 2.18 -4.82 4.86 -4.82 c2.66 0 4.82 2.16 4.82 4.82 c0 0.74 -0.2 1.54 -0.58 2.28 l-0.02 0.06 z M43.4 7.98 c-1.2 0 -2.16 1 -2.16 2.2 c0 1.18 0.98 2.2 2.16 2.2 c1.16 0 2.16 -1.02 2.16 -2.2 c0 -1.2 -0.98 -2.2 -2.16 -2.2 z"/>
            </g>
          </svg>
          
          </Link>
        </div>

        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <a href="#home" onClick={() => scrollToSection('home')}>Acasa</a>
          <a href="#about" onClick={() => scrollToSection('about')}>La VIBE9</a>
          <a href="#services" onClick={() => scrollToSection('services')}>Serviciile Noastre</a>
          <a href="#form" onClick={() => scrollToSection('form')}>Formular de Închiriere</a>
          <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 